import React from "react";
import {
  View,
  Text,
  Platform,
  StyleSheet,
  TouchableOpacity,
} from "react-native";
import AppTheme from "../../AppTheme";

import MoodsHelper from "../../common/mood/MoodsHelper";

export default function ReportHours({ mood, hours, onPress = () => {} }) {
  const gemStyle = MoodsHelper.geReflectionGemStyle(mood);
  const gemTextColor =
    MoodsHelper.getTextColorByMood(mood) || AppTheme.almostBlack;

  return hours ? (
    <TouchableOpacity style={[gemStyle, styles.tile]} onPress={onPress}>
      <View style={[styles.numbers]}>
        <Text
          style={[
            styles.hoursText,
            { color: gemTextColor },
            hours >= 1000 && styles.hoursTextSmall,
          ]}
        >
          {hours}
        </Text>
      </View>
    </TouchableOpacity>
  ) : (
    <View style={styles.tile} />
  );
}

const styles = StyleSheet.create({
  tile: {
    width: 28,
    height: 28,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  numbers: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "row",
    paddingVertical: 5,
    //paddingHorizontal: 6,
    minWidth: 34,
  },
  hoursText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  hoursTextSmall: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontSize: 10,
    lineHeight: 15,
  },
  minutesText: {
    fontWeight: "400",
    fontSize: 9,
  },
});
